import { NgFor, NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { datatypesOperator, filter_number, filter_string, number_datatype, string_datatype } from '@processo/consts/filter.const';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';

@Component({
  selector: 'app-filter-select-entity-field',
  imports: [NzSelectModule, FormsModule,NgIf,NgFor,NzInputModule],
  templateUrl: './filter-select-entity-field.component.html',
  styleUrl: './filter-select-entity-field.component.scss',
})
export class FilterSelectEntityFieldComponent implements OnInit {
  @Input() default_data: any;
  @Input() filter: any;
  @Input() filters: any;
  private actualMainEntity: string = '';
  searchTerm: string = '';
  expandedEntities: { [key: string]: boolean } = {};
  ngOnInit(): void {
    // Store the main entity's name on initialization for later reference
    this.actualMainEntity = this.default_data?.entity?.name;
  }
    // Filtered non-priority fields for main entity based on search
  getFilteredMainEntityNonPriorityFields() {
    const fields = this.getMainEntityNonPriorityFields();
    if (!this.searchTerm) return fields;
    return fields.filter((field: any) => field.label.toLowerCase().includes(this.searchTerm));
  }
    // Get priority fields for main entity
  getMainEntityPriorityFields() {
    return this.default_data?.entity?.fields?.filter((f: any) => 
      f.is_pf === true && 
      f?.datatype !== 'entity' && 
      f?.datatype !== 'textarea' && 
      f?.datatype !== 'attachment'
    )?.sort((a: any, b: any) => a.label?.localeCompare(b.label)) || [];
  }
    // Get entity name by label (helper method)
  getEntityNameByLabel(entityLabel: string): string {
    if (entityLabel === this.default_data?.entity?.display_name) {
      return this.default_data?.entity?.name;
    }
    const childData = this.default_data?.child_data?.find((c: any) => c.label === entityLabel);
    return childData?.entity_name || '';
  }

    private getChildEntityFields(childEntityName: string) {
    //console.log('getChildEntityFields called with:', childEntityName);
    
    const childEntity = this.default_data?.meta_data?.entities?.find((e: any) => e.name === childEntityName);
    const fields = childEntity?.fields?.filter(
      (e: any) =>
        e?.datatype !== 'entity' &&
        e?.datatype !== 'textarea' &&
        e?.datatype !== 'attachment'
    );
    
    //console.log('Child entity fields found:', fields?.length || 0);
    return fields;
  }
    getOperators(field: any, entityName: any): any {
      //console.log('getOperators called with field:', field, 'entityName:', entityName);
      
      let actualField = field;
      let actualEntityName = entityName;
      
      // Handle parent-child filters
      if (field && field.includes('~')) {
        // For parent-child filters like 'parentField~childField', resolve child via child_data map
        const [parentField, childField] = field.split('~');
        const childMap = this.default_data?.child_data?.find((cd: any) => cd.field_name === parentField);
        if (childMap?.entity_name) {
          actualField = childField;
          actualEntityName = childMap.entity_name;
        }
      }
      
      // Determine if this is a child entity by checking if entityName exists in child_data
      const isChildEntity = this.default_data?.child_data?.some((cd: any) => 
        cd.entity_name === actualEntityName || cd.field_name === actualEntityName
      );
      //console.log('isChildEntity:', isChildEntity);
      
      // Get fields from the correct entity
      let fields;
      if (actualEntityName === this.actualMainEntity) {
        //console.log('Using getFields for main entity');
        fields = this.getFields(actualEntityName);
      } else if (isChildEntity) {
        //console.log('Using getChildEntityFields for child entity');
        // If it's a child entity, get the actual entity name from child_data
        const childDataEntry = this.default_data?.child_data?.find((cd: any) => 
          cd.entity_name === actualEntityName || cd.field_name === actualEntityName
        );
        const actualChildEntityName = childDataEntry?.entity_name || actualEntityName;
        //console.log('Actual child entity name:', actualChildEntityName);
        fields = this.getChildEntityFields(actualChildEntityName);
      } else {
       // console.log('Fallback to getFields');
        // Fallback to getFields for main entity
        fields = this.getFields(actualEntityName);
      }
      
      //console.log('Fields for operators:', fields?.length || 0);
      
      const selectedtype = fields?.find((item: any) => item?.name === actualField)?.datatype;
      //console.log('Selected datatype:', selectedtype);
      
      const operators = datatypesOperator[selectedtype];
     // console.log('Available operators:', operators?.length || 0);
    
      return operators?.sort((a: any, b: any) =>
        a?.label?.localeCompare(b?.label)
      );
    }
    filterTypeFieldChange(event: any, i: any, entityName: any) {
    const fields = this.getFields(entityName);
    const selectedField = fields?.find((item: any) => item?.name === event);
    if (selectedField) {
      if (
        [
          'dropdown_single_select',
          'people',
          'dropdown_multi_select',
          'status',
          'tag',
          'priority',
          'phone',
          'website',
          'email',
          'textbox',
          'location',
        ].includes(selectedField?.datatype)
      ) {
        this.filters[i].key3 = [];
      }
      if (
        [
          'currency',
          'progress',
          'number',
          'ratings',
          'rating',
          'time',
        ].includes(selectedField?.datatype)
      ) {
        this.filters[i].key3 = null;
      }
      const operators = this.getOperators(this.filters[i]?.key1, entityName) || [];
      if ([
        'textbox', 'dropdown_single_select', 'dropdown_multi_select', 'status', 'tag', 'priority', 'phone', 'website', 'people', 'email', 'location'
      ].includes(selectedField?.datatype)) {
        const inOp = operators.find((op: { label: string; value: string }) => op.label === 'in');
        this.filters[i].key2 = inOp ? inOp.value : (operators[0]?.value || '');
      } else if (selectedField?.datatype === 'date' || selectedField?.datatype === 'datetime') {
        const btwOp = operators.find((op: { label: string; value: string }) => op.label === 'between');
        this.filters[i].key2 = btwOp ? btwOp.value : (operators[0]?.value || '');
      } else if ([
        'number', 'currency', 'progress', 'ratings', 'rating', 'time'
      ].includes(selectedField?.datatype)) {
        const eqOp = operators.find((op: { label: string; value: string }) => op.label === '=' || op.label === 'is');
        this.filters[i].key2 = eqOp ? eqOp.value : (operators[0]?.value || '');
      } else if (selectedField?.datatype === 'checkbox') {
        const selOp = operators.find((op: { label: string; value: string }) => op.label === 'is selected');
        this.filters[i].key2 = selOp ? selOp.value : (operators[0]?.value || '');
      } else {
        this.filters[i].key2 = operators[0]?.value || '';
      }
    }
  }
    // Get all fields for child entity (helper method)
  getChildEntityAllFields(entityName: string) {
    const fields = this.default_data?.meta_data?.entities
      ?.find((e: any) => e.name === entityName)
      ?.fields?.filter(
        (e: any) =>
          e?.datatype !== 'entity' &&
          e?.datatype !== 'textarea' &&
          e?.datatype !== 'attachment' &&
          this.shouldShowFieldInEntity(e, entityName) // Add this line to apply relationship filtering
      )
      ?.sort((a: any, b: any) => a.label?.localeCompare(b.label)) || [];
    return fields;
  }
    // Get non-priority fields for main entity
  getMainEntityNonPriorityFields() {
    return this.default_data?.entity?.fields?.filter((f: any) => 
      f.is_pf !== true && 
      f?.datatype !== 'entity' && 
      f?.datatype !== 'textarea' && 
      f?.datatype !== 'attachment'
    )?.sort((a: any, b: any) => a.label?.localeCompare(b.label)) || [];
  }
    // Get non-priority fields for child entity
  getChildEntityNonPriorityFields(entityName: string) {
    const fields = this.getChildEntityAllFields(entityName)?.filter((f: any) => f.is_pf !== true) || [];
    return fields;
  }
    // Get priority fields for child entity
  getChildEntityPriorityFields(entityName: string) {
    const fields = this.getChildEntityAllFields(entityName)?.filter((f: any) => f.is_pf === true) || [];
    return fields;
  }
    shouldShowEntity(entityLabel: string): boolean {
    if (!this.searchTerm) return true;
    
    // Show entity if any of its fields match the search term
    const entityName = this.getEntityNameByLabel(entityLabel);
    const allFields = entityName === this.default_data?.entity?.name 
      ? [...this.getMainEntityPriorityFields(), ...this.getMainEntityNonPriorityFields()]
      : [...this.getChildEntityPriorityFields(entityName), ...this.getChildEntityNonPriorityFields(entityName)];
    
    return allFields.some(field => 
      field.label.toLowerCase().includes(this.searchTerm) ||
      entityLabel.toLowerCase().includes(this.searchTerm)
    );
  }
    // Handle search input change
  onSearchChange(event: any) {
    this.searchTerm = event.target?.value?.toLowerCase() || '';
  }
    // Updated onCombinedFieldSelection 
  onCombinedFieldSelection(value: string, filter: any) {
    if (!value) {
      filter.entity_name = '';
      filter.key1 = '';
      filter.key2 = '';
      filter.key3 = '';
      return;
    }
    console.log(value,'123')
    const [entityName, fieldName] = value.split('|');
    filter.entity_name = entityName;
    
    // Check if this is a parent-child relationship
    const currentEntityName = this.default_data?.entity?.name;
    if (entityName !== currentEntityName) {
      // This is a parent-child filter, create composite key
      filter.key1 = `${entityName}~${fieldName}`;
    } else {
      filter.key1 = fieldName;
    }
    
    filter.key2 = '';
    filter.key3 = '';
    
    const filterIndex = this.filters.indexOf(filter);
    this.filterTypeFieldChange(fieldName, filterIndex, entityName);
  }
  // Update isRelationshipField to use the stored main entity
  private isRelationshipField(
    field: any,
    fieldEntityName: string,
    actualMainEntityName: string
  ): boolean {
    // This check only applies to fields that belong to a parent entity.
    if (fieldEntityName === actualMainEntityName) {
      return false;
    }

    const mainEntity = this.default_data.meta_data?.entities?.find(
      (e: any) => e.name === actualMainEntityName
    );
    if (!mainEntity) {
      return false;
    }

    // Find if a dropdown field in the main entity uses this specific parent field as its data source.
    const isUsedAsDataSource = mainEntity.fields.some(
      (mainEntityField: any) =>
        // 1. Is the main entity's field an ENTITY_DATA dropdown?
        (mainEntityField.datatype === 'dropdown_single_select' ||
          mainEntityField.datatype === 'dropdown_multi_select') &&
        mainEntityField.option_type === 'ENTITY_DATA' &&
        // 2. Does its name match the parent field's name?
        mainEntityField.name === field.name &&
        // 3. (THE CRUCIAL FIX) Does it point specifically to the parent entity we are currently checking?
        mainEntityField.entity_name === fieldEntityName
    );

    if (isUsedAsDataSource) {
      // Hide the field only if all three conditions are met.
      return true;
    }

    return false;
  }
  private shouldShowFieldInEntity(field: any, entityName: string): boolean {
    // If we are listing fields for the main entity itself, always show them.
    if (entityName === this.actualMainEntity) {
      return true;
    }

    // For parent entities, hide fields that are identified as relationship links.
    const isRelationship = this.isRelationshipField(
      field,
      entityName,
      this.actualMainEntity
    );
    return !isRelationship;
  }
  getFields(entityName: any) {
    let entity_Name = this.default_data.child_data?.find(
      (_e: any) => _e?.field_name === entityName
    )?.entity_name;

    // If entity_Name is undefined, it means this is the main entity
    if (!entity_Name) {
      // Check if entityName exists as an entity name in child_data
      const childDataEntry = this.default_data.child_data?.find(
        (cd: any) => cd.entity_name === entityName
      );
      //console.log('Child data entry found:', childDataEntry);

      if (childDataEntry) {
        // This is a child entity name, use it directly
        entity_Name = entityName;
        //console.log('Using child entity name directly:', entity_Name);
      } else {
        // If still undefined, it means this is the main entity
        entity_Name = this.actualMainEntity;
        // console.log('Using main entity name:', entity_Name);
      }
    }

    const entity = this.default_data.meta_data?.entities.find(
      (e: any) => e.name === entity_Name
    );
    const allFields = entity?.fields?.filter(
      (e: any) =>
        e?.datatype !== 'entity' &&
        e?.datatype !== 'textarea' &&
        e?.datatype !== 'attachment'
    );
    const fields = allFields?.filter(
      (e: any) => this.shouldShowFieldInEntity(e, entity_Name) // This calls the updated logic
    );
    //console.log('Fields after shouldShowFieldInEntity filtering:', fields?.length || 0);

    const result = fields?.sort((a: any, b: any) =>
      a.label?.localeCompare(b.label)
    );
    //console.log('Final result:', result?.length || 0);
    return result;
  }
  private getChildFieldLabel(
    childEntityName: string,
    fieldName: string
  ): string {
    //console.log('getChildFieldLabel called with:', childEntityName, fieldName);

    // Get fields from the child entity
    const childEntity = this.default_data?.meta_data?.entities?.find(
      (e: any) => e.name === childEntityName
    );
    const childFields = childEntity?.fields?.filter(
      (e: any) =>
        e?.datatype !== 'entity' &&
        e?.datatype !== 'textarea' &&
        e?.datatype !== 'attachment'
    );

    //console.log('Child entity fields:', childFields?.length || 0);

    const field = childFields?.find((f: any) => f.name === fieldName);
    //console.log('Found child field:', field?.name, field?.label);

    const result = field?.label || fieldName;
    //console.log('Child field label result:', result);
    return result;
  }
  getFieldLabelByName(entityName: string, fieldName: string): string {
    //console.log('getFieldLabelByName called with:', entityName, fieldName);

    // For parent-child filters, we need to find the actual entity
    let actualEntityName = entityName;

    // Check if entityName is a parent field name (like "pn")
    const childDataEntry = this.default_data?.child_data?.find(
      (cd: any) => cd.field_name === entityName
    );

    if (childDataEntry) {
      // This is a parent field, get the actual entity name
      actualEntityName = childDataEntry.entity_name;
      //console.log('Found parent field, actual entity name:', actualEntityName);
    }

    const fields = this.getFields(entityName); // Keep original entityName for getFields
    //console.log('Found fields for entity:', fields);

    const field = fields?.find((f: any) => f.name === fieldName);
    // console.log('Found field:', field);

    const result = field?.label || fieldName;
    //console.log('Field label result:', result);
    return result;
  }
  // New helper method to get only the child field name for parent-child filters
  private getChildFieldNameOnly(filter: any): string {
    //console.log('getChildFieldNameOnly called with:', filter);

    // Parse the composite key: 'pn~cs' -> parentField='pn', childField='cs'
    const [parentField, childField] = filter.key1.split('~');
    //console.log('Parsed parent field:', parentField, 'child field:', childField);

    // Resolve child entity via child_data map
    const childMap = this.default_data?.child_data?.find(
      (cd: any) => cd.field_name === parentField
    );
    if (childMap?.entity_name) {
      const childFieldLabel = this.getChildFieldLabel(
        childMap.entity_name,
        childField
      );
      return childFieldLabel;
    }
    // Fallback - return just the child field name
    return childField;
  }
  // Helper method to get current combined value for display
  getCombinedValue(filter: any) {
    if (filter?.entity_name && filter?.key1) {
      // Check if this is a parent-child filter by looking for ~ in key1
      if (filter.key1.includes('~')) {
        // For parent-child filters like {entity_name: 'pn', key1: 'pn~cs'}
        // Only show the child field name, not "Parent > Child"
        return this.getChildFieldNameOnly(filter);
      } else {
        // Regular field - show only field label
        const fieldLabel = this.getFieldLabelByName(
          filter.entity_name,
          filter.key1
        );
        //console.log('fieldLabel:', fieldLabel);
        //console.log('Final result:', fieldLabel);
        return fieldLabel;
      }
    }
    // console.log('Returning null - missing entity_name or key1');
    return null;
  }
   // Filtered priority fields for main entity based on search
  getFilteredMainEntityPriorityFields() {
    const fields = this.getMainEntityPriorityFields();
    if (!this.searchTerm) return fields;
    return fields.filter((field: any) => field.label.toLowerCase().includes(this.searchTerm));
  }
    // Select a field with specific filter parameter - FIXED VERSION
  selectFieldWithFilter(entityName: string, fieldName: string, fieldLabel: string, filter: any) {
    filter.entity_name = entityName;
    
    // Check if this is a parent-child relationship
    const currentEntityName = this.default_data?.entity?.name;
    if (entityName !== currentEntityName) {
      // This is a parent-child filter, create composite key
      filter.key1 = `${entityName}~${fieldName}`;
    } else {
      filter.key1 = fieldName;
    }
    
    filter.key2 = '';
    filter.key3 = '';
    
    // Find the filter index for setting default operator
    const filterIndex = this.filters.indexOf(filter);
    if (filterIndex === -1) {
      // If filter is inside an array (group), find its parent
      for (let i = 0; i < this.filters.length; i++) {
        if (Array.isArray(this.filters[i])) {
          const subIndex = this.filters[i].indexOf(filter);
          if (subIndex !== -1) {
            this.filterTypeFieldChange(fieldName, i, entityName);
            break;
          }
        }
      }
    } else {
      this.filterTypeFieldChange(fieldName, filterIndex, entityName);
      this.set_key2value(filter.key2, filter);
    }
    
    // Clear search term
    this.searchTerm = '';
    
    // Close dropdown - improved approach
    setTimeout(() => {
      // Try multiple methods to ensure dropdown closes
      const selectElements = document.querySelectorAll('nz-select');
      selectElements.forEach((select: any) => {
        if (select.blur) {
          select.blur();
        }
        // Also try to close via nz-select service
        if (select.nzSelectService) {
          select.nzSelectService.setOpenState(false);
        }
      });
      
      // Fallback: simulate outside click
      document.body.click();
    }, 50);
  }
    set_key2value(event: any, filter: any) {
      // Normalize entity and field for parent-child selections
      let lookupEntity = filter?.entity_name;
      let lookupField = filter?.key1;
      if (typeof filter?.key1 === 'string' && filter.key1.includes('~')) {
        const [parentField, childField] = filter.key1.split('~');
        const childMap = this.default_data?.child_data?.find((cd: any) => cd.field_name === parentField);
        if (childMap?.entity_name) {
          lookupEntity = childMap.entity_name;
          lookupField = childField;
        }
      }
      const fields = this.getFields(lookupEntity);
      const selectedField = fields?.find((item: any) => item?.name === lookupField);
      filter.key2 = event;
      if (filter.key2 === '$null') {
        filter.key3 = 'true';
      } else if (filter.key2 === '$nnull') {
        filter.key3 = 'false';
      } else if (filter.key2 === '$btw' && selectedField) {
        if (string_datatype?.includes(selectedField?.datatype)) {
          filter.key3 = filter_string;
        } else if (number_datatype?.includes(selectedField?.datatype)) {
          filter.key3 = filter_number;  
        }
      }
      else if ((filter.key2 === '$in' || filter.key2 === '$nin') && 
      ['textbox', 'email', 'website'].includes(selectedField?.datatype)) {
  filter.key3 = [];
  //this.loadAutocompleteData(filter.entity_name, filter.key1);
  }
      else{
        if (
          [
            'dropdown_single_select',
            'people',
            'dropdown_multi_select',
            'status',
            'tag',
            'priority',
          ].includes(selectedField?.datatype)
        ) {
          filter.key3 = [];
        }else if (
          ['currency', 'progress', 'number', 'ratings', 'rating', 'time'].includes(
            selectedField?.datatype
          )
        ) {
          filter.key3 = null;
        }else{
          filter.key3 = '';
        }
      }
    }
    key2value(filter: any) {
      if (filter.key2 === '$null' && filter.key3 === 'false') {
        return '$nnull';
      }
      return filter.key2;
    }
      // Check if a field is currently selected - Updated to use specific filter
  isSelected(entityName: string, fieldName: string, filter: any): boolean {
    const currentEntityName = this.default_data?.entity?.name;
    
    if (entityName !== currentEntityName) {
      // For parent-child relationships, check for composite key
      const compositeKey = `${entityName}~${fieldName}`;
      return filter?.entity_name === entityName && filter?.key1 === compositeKey;
    } else {
      // For same entity, check regular field name
      return filter?.entity_name === entityName && filter?.key1 === fieldName;
    }
  }
    // Toggle expansion state for an entity
  toggleEntityExpansion(entityKey: string) {
    this.expandedEntities[entityKey] = !this.expandedEntities[entityKey];
  }
    // Filtered priority fields for child entity based on search
  getFilteredChildEntityPriorityFields(entityName: string) {
    const fields = this.getChildEntityPriorityFields(entityName);
    if (!this.searchTerm) return fields;
    return fields.filter((field: any) => field.label.toLowerCase().includes(this.searchTerm));
  }
    // Filtered non-priority fields for child entity based on search
  getFilteredChildEntityNonPriorityFields(entityName: string) {
    const fields = this.getChildEntityNonPriorityFields(entityName);
    if (!this.searchTerm) return fields;
    return fields.filter((field: any) => field.label.toLowerCase().includes(this.searchTerm));
  }
}
